import { render, staticRenderFns } from "./Paso2View.vue?vue&type=template&id=6713aff8&scoped=true&"
import script from "./Paso2View.vue?vue&type=script&lang=js&"
export * from "./Paso2View.vue?vue&type=script&lang=js&"
import style0 from "./Paso2View.vue?vue&type=style&index=0&id=6713aff8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713aff8",
  null
  
)

export default component.exports